/* global frontendi18n, jQuery */

/**
* File modal-focus-trap.js
*
* Traps focus within the Numerator modal.
*/
window.wdsModalFocusTrap = {};
( function( window, app ) {

	// Constructor.
	app.init = function() {
		app.cache();

		if ( app.meetsRequirements() ) {
			app.initializeMutationObserver();
		}
	};

	// Cache all the things.
	app.cache = function() {
		app.$c = {
			body: document.body
		};
	};

	// Combine all events.
	app.bindEvents = function() {
		app.$c.window.on( 'load', app.initializeMutationObserver );
		app.$c.window.on( 'resize', app.refreshFocusableModalElements );
	};

	// Only run this when we are on a single product page.
	app.meetsRequirements = function() {
		return app.$c.body.classList.contains( 'single-product' );
	};

	// Initialize Mutation Observer.
	app.initializeMutationObserver = function() {
		var observeTarget = app.$c.body;

		var config = {
			attributes: false,
			childList: true,
			subtree: false
		};

		// Create an observer instance linked to the callback function.
		var observer = new MutationObserver( app.numeratorModalObserverCallback );

		// Start observing the target node for configured mutations.
		observer.observe( observeTarget, config );
	};

	app.numeratorModalObserverCallback = function( mutationsList ) {

		// Use traditional 'for loops' for IE 11
		for ( let mutation of mutationsList ) {
			if ( 0 === mutation.addedNodes.length ) {
				continue;
			}

			if ( 'ciq-modal-overlay' === mutation.addedNodes[0].id ) {
				app.fixModal( mutation.addedNodes[0] );
				app.watchModal( mutation.addedNodes[0] );
				break;
			}
		}
	};

	// Fix some of the attributes on the modal.
	app.fixModal = function() {
		var closeButton = document.getElementById( 'ciq-modal-close' );

		closeButton.setAttribute( 'aria-label', frontendi18n.closeModal );
	};

	// Now we need to watch this modal, since only its style attribute is changed.
	app.watchModal = function( modalNode ) {
		var observeTarget = modalNode;

		var config = {
			attributes: true,
			childList: false,
			subtree: false,
			attributeFilter: [ 'style' ]
		};

		// Create an observer instance linked to the callback function.
		var observer = new MutationObserver( app.trapModalFocus );

		// Start observing the target node for configured mutations.
		observer.observe( observeTarget, config );
	};

	// Set or unset the event management for trapping the focus inside of the modal.
	app.trapModalFocus = function( mutationRecord ) {
		var modal = mutationRecord[0].target;

		if ( 'none' === modal.style.display ) {
			app.releaseFocus();
		} else {
			app.trapFocus();
		}
	};

	// Release the focus trap and move focus to the Buy Now button.
	app.releaseFocus = function() {
		var dialog = document.getElementById( 'ciq-modal' );

		dialog.removeEventListener( 'keydown', app.moveFocus );
		document.getElementById( 'wtb' ).focus();
	};

	// Trap focus within the modal with ally.js.
	app.trapFocus = function() {
		var dialog = document.getElementById( 'ciq-modal' );

		app.$c.$focusableChildren = jQuery( dialog ).find( 'a:visible, :input:visible, [tabindex]:visible, button:visible' );
		app.$c.$focusableChildren[0].focus();

		dialog.addEventListener( 'keydown', app.moveFocus );
	};

	// Check and move focus around where needed.
	app.moveFocus = function( event ) {

		// We only need to do stuff when the modal is open and tab is pressed.
		if ( 9 === event.which ) {
			let $focused = jQuery( ':focus' ),
				focusIndex = app.$c.$focusableChildren.index( $focused );

			if ( 0 === focusIndex && event.shiftKey ) {

				// If this is the first focusable element, and shift is held when pressing tab, go back to last focusable element.
				app.$c.$focusableChildren[ app.$c.$focusableChildren.length - 1 ].focus();
				event.preventDefault();
			} else if ( ! event.shiftKey && focusIndex === app.$c.$focusableChildren.length - 1 ) {

				// If this is the last focusable element, and shift is not held, go back to the first focusable element.
				app.$c.$focusableChildren[0].focus();
				event.preventDefault();
			}
		}
	};

	// The modal seems to contain focusable elements that get hidden at certain breakpoints. So we need to keep track of that on resize.
	app.refreshFocusableModalElements = function() {
		var dialog = document.getElementById( 'ciq-modal' );

		app.$c.$focusableChildren = jQuery( dialog ).find( 'a:visible, :input:visible, [tabindex]:visible, button:visible' );
	};

	// Engage!
	app.init();

}( window, window.wdsModalFocusTrap ) );
